module.exports = __webpack_public_path__ + "static/media/albania.f8a562c9.png";